<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
              <div class="row">
                <div class="col-md-3">
                  <div class="card">
                  <div class="card-body p-2">
                    <div class=" mb-2 d-flex justify-content-between">
                      <span><a @click="$router.go(-1)" type="button" class="btn-sm btn btn-primary"> <i class="mdi mdi-undo"></i> back</a></span>
                      <img class="img-rounded" src="@/assets/images/sick.png" height="70px" />
                      <span><router-link :to="{ path: '/insuranceprintprofile',  query: { id: this.$route.query.id, visit_id: this.$route.query.visit_id}}" type="button" class="btn-sm btn btn-primary"> <i class="mdi mdi-printer"></i> Print</router-link></span>
                    </div>
                    <table v-for="item in patients" :key="item.id" class="table">
                    <tr><td>Full Name </td><td> <b class="text-primary h7">{{ item.name }} </b></td></tr>
                    <tr><td>Gender </td><td> <span class="text-primary h7">{{ item.gender }} </span></td></tr>
                    <tr><td> Telephone </td><td> <span class="text-primary h7">0{{ item.telephone }} </span></td></tr>
                    <tr><td> Age </td><td> <span class="text-primary h7">{{ getAge(item.date_of_birth) }}  </span></td></tr>
                    <tr><td> Address </td><td> <span class="text-primary h7">{{ item.address }} </span></td></tr>
                    <tr><td> Nationality </td><td> <span class="text-primary h7">{{ item.nationality }} </span></td></tr>
                    <tr><td> Next of Kin </td><td> <span class="text-primary h7">{{ item.nokname}} </span></td></tr>
                    <tr><td> Next of Kin's Contact </td><td> <span class="text-primary h7">{{ item.nokcontact }} </span></td></tr>
                  </table>
                  </div>
                  </div>
                </div>
                <div class="col-md-9">
                  <b-tabs pills nav-class="p-0" content-class="text-primary">
                    <b-tab active class="border-0">
                      <template v-slot:title>Service</template>
                      <div class="card">
                        <div class="card-body">
                          <div class="card" v-for="item in visits" :key="item.id">

                          <b-card no-body class="mb-1">
                            <b-card-header header-tag="header" role="tab">
                              <!-- <h6 class="m-0"><a v-b-toggle="'accordion-'+item.id" class="text-dark" href="javascript: void(0);"><i class="mdi mdi-calendar"></i> {{ item.addedon }} <b class="text-black">{{ item.service_category ? item.service_category.name : 'N/A' }}</b>   <b class="text-info">{{ item.service_name && item.service_name.name ? item.service_name.name : item.insurance_service_name && item.insurance_service_name.name ? item.insurance_service_name.name : 'N/A' }}</b></a> -->
                                <h6 class="m-0"><a v-b-toggle="'accordion-'+item.id" class="text-dark" href="javascript: void(0);"><i class="mdi mdi-calendar"></i> {{ item.addedon }} <b class="text-black">{{ item.service_category ? item.service_category.name : 'N/A' }}</b>   <b class="text-info">{{   item.insurance_service_name.name  }}</b></a>

                                <span v-if="item.service_category && item.service_category.id==4">
                                  <span v-if="item.lab==0"><span class="btn btn-sm btn-danger"> Not Worked On</span></span>
                                <span v-else><span class="btn btn-sm btn-primary"> Worked On</span></span>
                                </span>
                                <span v-else class="ms-2"> <span v-if="item.treatment==0"><span class="btn btn-sm btn-danger"> Not Worked On</span></span>
                                <span v-else><span class="btn btn-sm btn-primary"> Worked On</span></span></span>
                              </h6>
                            </b-card-header>
                            <b-collapse :id="'accordion-'+item.id" accordion="my-accordion" role="tabpanel">
                              <b-card-body>
                                <div v-if="item.treatment==0 && item.lab==0">
                                  <span class="p-3"> No Details yet</span>
                                </div>
                                <div v-else>
                                <b-card-text v-if="item.service_category && item.service_category.id==4">
                                  <b>Results: </b>
                                  <span class="text-black" v-html="item.lab.result"></span><br>
                                </b-card-text>
                                <b-card-text v-else>
                                  <span v-if="item.service_category && item.service_category.id==3">
                                    <b>Results: </b>
                                    <span class="text-black" v-html="item.treatment.diagnosis"></span><br>
                                  </span>
                                  <span v-else>
                                  <b>Diagnosis: </b>
                                  <span class="text-black" v-html="item.treatment.diagnosis"></span><br>
                                  <b>Examination: </b>
                                  <span class="text-black" v-html="item.treatment.examination"></span><br>
                                  <b>Recommendation: </b>
                                  <span class="text-black" v-html="item.treatment.recommedation"></span>
                                </span>
                                </b-card-text>
                              </div>
                              </b-card-body>
                            </b-collapse>
                          </b-card>
                          </div>
                        </div>
                      </div>
                    </b-tab>
                    <!-- <b-tab class="border-0">
                      <template v-slot:title>Triage</template>
                      <div class="card">
                        <div class="card-body">
                          <table class="table table-sm mt-2" style="color: black;" density="compact">
                          <thead><tr><th>Temperature</th><th>Weight</th><th>Height</th><th>Muac</th><th>Blood Pressure</th><th>Pulse</th></tr></thead>
                          <tbody>
                            <tr v-for="item in triages" :key="item.id">
                                <td>{{ item.temperature }} <span class="text-primary">℃</span></td>
                                <td>{{ item.weight }} <span class="text-primary">Kgs</span></td>
                                <td>{{ item.height }} <span class="text-primary">cm</span></td>                                  
                                <td>{{ item.muac }} <span class="text-primary">cm</span></td>                                  
                                <td>{{ item.bloodpressure }} <span class="text-primary">mmHg</span></td>                                  
                                <td>{{ item.pulse }} <span class="text-primary">b/min</span></td>                                 
                            </tr>
                          </tbody>
                          </table>
                        </div>
                      </div>
                    </b-tab> -->
                    <!-- <b-tab class="border-0">
                      <template v-slot:title>Prescriptions</template>
                      <div class="card">
                        <div class="card-body">
                          <table class="table table-sm mt-2" style="color: black;" density="compact">
                          <thead><tr><th>Medicine</th><th>Unit</th><th>Price</th></tr></thead>
                          <tbody>
                            <tr v-for="item in prescriptions" :key="item.id">
                                <td>{{ item.medicine.name }}</td>
                                <td>{{ item.quantity }} {{ item.unit.unit_name }}</td>
                                <td>{{ item.totalprice }}</td>
                            </tr>
                          </tbody>
                          </table>
                        </div>
                      </div>
                    </b-tab> -->
                    <!-- <b-tab class="border-0">
                      <template v-slot:title>Payments</template>
                      <div class="card">
                        <div class="card-body">
                          <table class="table table-sm mt-2" style="color: black;" density="compact">
                          <thead><tr><th>Service total</th><th>Prescriptions</th><th>Amount Paid</th><th>Balance</th></tr></thead>
                          <tbody>
                            <tr v-for="item in payments" :key="item.id">
                                <td>{{ item.services }} </td>
                                <td>{{ item.prescriptions }}</td>
                                <td>{{ item.paid }}</td>                                  
                                <td>{{ item.balance }} </td>                                  
                            </tr>
                          </tbody>
                          </table>
                        </div>
                      </div>
                    </b-tab> -->
                    <!-- <b-tab class="border-0">
                      <template v-slot:title>Appointments</template>
                      <div class="card">
                      <div class="card-body">
                        <table class="table table-sm mt-2" style="color: black;" density="compact">
                        <thead><tr><th>Person to See</th><th>Appointment Date</th><th>Appointment Time</th></tr></thead>
                        <tbody>
                          <tr v-for="item in appointments" :key="item.id">
                            <td>{{ item.staff.full_name }} </td>
                            <td>{{ item.appointment_date }}</td>
                            <td>{{ item.appointment_time }}</td>
                          </tr>
                        </tbody>
                        </table>
                      </div>
                    </div>
                    </b-tab> -->
                    </b-tabs>
                </div>
              </div>
      </div>
    </div>
    
  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
// import {  insurancevisitMethods, insurancevisitComputed } from "@/state/helpers";


export default {
  page: {
    title: "Patient Profile",
    meta: [{name: "description",content: appConfig.description,},],
  },
  components: {
    Layout,
    PageHeader,
  },
  // computed: {
    
  //     ...insurancevisitComputed,
  //    },
  data() {
    return {
      title: "Patient Profile",
      items: [{text: "Dashboard",to: "/",},{text: "Patients",active: true,},],
      patients:[],
      visits:[],
      triages:[],
      appointments:[],
      prescriptions:[],
      payments:[],
      name:'',
      insurance_service_name:[],
      visit_id:'',
    };
  },
  created() {
    this.showpatient();
    this.showvisits();
    // this.fetchInsuranceVisits();
  },
  methods: {
    // ...insurancevisitMethods,
    // getAge(dateString){
    //   let birth = new Date(dateString); let now = new Date(); let beforeBirth = ((() => {birth.setDate(now.getDate());birth.setMonth(now.getMonth()); return birth.getTime()})() < birth.getTime()) ? 0 : 1;
    //   return now.getFullYear() - birth.getFullYear() - beforeBirth;
    // },
    getAge(dateString) {
  let birth = new Date(dateString);
  let now = new Date();

  let years = now.getFullYear() - birth.getFullYear();
  let months = now.getMonth() - birth.getMonth();

  // Adjust years and months if the current month hasn't reached the birth month yet
  if (months < 0) {
    years--;
    months += 12;
  }

  // Adjust months if the current day hasn't reached the birth day yet
  if (now.getDate() < birth.getDate()) {
    months--;
    if (months < 0) {
      years--;
      months += 12;
    }
  }

  if (years > 0) {
    // return `${years} years and ${months} months old`;    

    return `${years} years `;

  } else {
    return `${months} months old`;
  }
},
    async showpatient(){
      this.patient_id=this.$route.query.id;
      let url = `/patientprofile/${this.patient_id}`;
      await axios.get(url).then((response) => {
        this.patients = response.data.patients;
      });
    },
    async showvisits(){
      this.visit_id=this.$route.query.visit_id;
      // this.patient_id=this.$route.query.id
      // let url = `/profilevisits/${this.patient_id}`;
      let url = `/insuranceprofilevisits/${this.visit_id}`;
      await axios.get(url).then((response) => {
        this.visits = response.data.visits;
       
        this.showtriages();
        this.showtappointments();
        this.showprescriptions();
        this.showpayments();
      });
    },
    async showtriages(){
      this.patient_id=this.$route.query.id;
      let url = `/profiletriages/${this.patient_id}`;
      await axios.get(url).then((response) => {
        this.triages = response.data.triages;
      });
    },
    async showtappointments(){
      this.patient_id=this.$route.query.id;
      let url = `/patientappointment/${this.patient_id}`;
      await axios.get(url).then((response) => {
        this.appointments = response.data.appointments;
      });
    },
    async showprescriptions(){
      this.patient_id=this.$route.query.id;
      let url = `/profileprescriptions/${this.patient_id}`;
      await axios.get(url).then((response) => {
        this.prescriptions = response.data.prescriptions;
      });
    },
    async showpayments(){
      this.visit_id=this.$route.query.visit_id;
      let url = `/insuranceprofilepayments/${this.visit_id}`;
      await axios.get(url).then((response) => {
        this.payments = response.data.debts;
      });
    },
  },
};
</script>